module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgzOC43IDI2NS4xYTQwIDQwIDAgMCAxIDU2LjYgNTYuNkw0NTQuMSA3NjIuOGE0MCA0MCAwIDAgMS01Ni43LTAuMUwxODIuNCA1NDcuOGE0MCA0MCAwIDAgMSA1Ni42LTU2LjZsMTg2LjggMTg2LjhMODM4LjcgMjY1LjF6IiBmaWxsPSIjMCIgcC1pZD0iNTI1MSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Checkmark Origin-outlined.svg
// module id = +PMo
// module chunks = 75